import { z } from 'zod';

// NOTIFY payload schemas (PR 4) ------------------------------------------
//
// Emitted by the lifecycle RPCs in 0032 and consumed by the bot's dispatch
// listeners. Payloads are intentionally minimal (id + a handful of fields
// the listener needs to act without a second DB hop). camelCase mirrors
// the convention from json_build_object in the existing migrations.

export const FormPostRequestPayloadSchema = z.object({
  formId: z.string().uuid(),
  studioId: z.string().uuid(),
  gameId: z.string().uuid(),
  surveyChannelId: z.string().min(1),
  postedMessageId: z.string().nullable(),
});
export type FormPostRequestPayload = z.infer<typeof FormPostRequestPayloadSchema>;

export const FormDisableRequestPayloadSchema = z.object({
  formId: z.string().uuid(),
  studioId: z.string().uuid(),
  surveyChannelId: z.string().nullable(),
  postedMessageId: z.string().nullable(),
});
export type FormDisableRequestPayload = z.infer<typeof FormDisableRequestPayloadSchema>;

export const FormPermCheckRequestPayloadSchema = z.object({
  formId: z.string().uuid(),
  studioId: z.string().uuid(),
  gameId: z.string().uuid(),
  surveyChannelId: z.string().nullable(),
  responseChannelId: z.string().nullable(),
  // Story 10B: recruit ids are echoed in the NOTIFY so the bot can run
  // its per-role / per-channel checks without re-reading the row.
  // Default to [] for older NOTIFY shapes that pre-date the recruit
  // feature (none in production, but keeps tests cheap to seed).
  recruitChannelIds: z.array(z.string()).default([]),
  recruitRoleIds: z.array(z.string()).default([]),
});
export type FormPermCheckRequestPayload = z.infer<typeof FormPermCheckRequestPayloadSchema>;

// Emitted by both pg_cron (enqueue_form_reposts) and the portal-facing
// request_form_repost RPC. Single shape so the bot listener has one entry
// point regardless of which side fired the NOTIFY.
export const FormRepostRequestPayloadSchema = z.object({
  formId: z.string().uuid(),
  queueRowId: z.string().uuid(),
});
export type FormRepostRequestPayload = z.infer<typeof FormRepostRequestPayloadSchema>;
